import React, { useEffect, useState, useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import {
  Box,
  Chip,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Rating,
  Tooltip,
  CircularProgress,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { grey, orange, purple } from "@mui/material/colors";
import CancelIcon from "@mui/icons-material/Cancel";
import Tab from "@mui/material/Tab";
// import TabList from '@mui/lab/TabList';
import styled from "@emotion/styled";
import "react-quill/dist/quill.snow.css";
import PropTypes from "prop-types";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import Timeline from "pages/Timeline/Timeline";
import moment from "moment";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const SProfileBox = styled(Box)({
  minHeight: "25px",
  margin: "4px",
  display: "flex",
  justifyContent: "space-between",
  alignContent: "center",
});

const SButton4 = styled(Button)({
  background: orange[400],
  border: `1px solid ${orange[400]}`,
  color: "#FFFFFF",
  borderRadius: "8px",
  textTransform: "none",
  padding: "4px",
  width: "130px",
  "&:hover": {
    background: orange[400],
    border: `1px solid ${orange[400]}`,
  },
});

const SButton5 = styled(Button)({
  background: orange[300],
  border: `1px solid ${orange[300]}`,
  color: "#FFFFFF",
  borderRadius: "8px",
  textTransform: "none",
  padding: "4px",
  width: "130px",
  "&:hover": {
    background: orange[300],
    border: `1px solid ${orange[300]}`,
    cursor: "no-drop",
  },
});

export default function SideDrawer(props) {
  const {
    openModal,
    setOpenModal,
    veridetails,
    setVeridetails,
    timelineLoading,
    setTimeLineLoading,
    time,
    setTime,
    candData,
    setCandData,
  } = props;

  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <React.Fragment>
      <Dialog
        fullScreen
        sx={{ mt: 10, ml: 2, boxShadow: "0px 12px 60px rgba(59, 80, 146, 0.25)" }}
        open={openModal}
        onClose={handleClose}
        TransitionComponent={Transition}
        hideBackdrop={true}
      >
        <DialogTitle
          sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          <Typography variant="h6"></Typography>

          <IconButton onClick={handleClose} sx={{ p: 0, m: 0 }}>
            <CancelIcon sx={{ color: grey[400] }} />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <Grid container spacing={2} sx={{ height: "100%" }}>
            <Grid item lg={8} md={12} sm={12} xs={12}>
              <Box
                sx={{
                  width: "100%",
                  border: "1px solid grey",
                  height: "100%",
                  borderRadius: "12px",
                  p: 1,
                }}
              >
                <Grid container spacing={2}>
                  <Grid item lg={6} sm={6} md={12} xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        height: "100%",
                      }}
                    >
                      <SProfileBox>
                        <SoftTypography fontWeight="500" fontSize="15px" lineHeight="30px">
                          Name: {veridetails?.first_name ? veridetails?.first_name : "-"}{" "}
                          {veridetails?.last_name ? veridetails?.last_name : ""}
                        </SoftTypography>
                      </SProfileBox>
                    </Box>
                  </Grid>

                  <Grid item lg={6} sm={6} md={12} xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        height: "100%",
                      }}
                    >
                      {candData?.resume_cv !== null ? (
                        <a href={candData?.resume_cv} target="_blank" rel="noreferrer">
                          <SButton4>
                            <SoftTypography bgColor="#9747FF" color="white" fontSize="15px">
                              Resume
                            </SoftTypography>
                          </SButton4>
                        </a>
                      ) : (
                        <SButton5>
                          <SoftTypography bgColor="#9747FF" color="white" fontSize="15px">
                            Resume
                          </SoftTypography>
                        </SButton5>
                      )}
                    </Box>
                  </Grid>
                </Grid>
                <hr />

                <Grid container>
                  <Grid item lg={6} sm={12} md={12} xs={12}>
                    <SProfileBox>
                      <SoftBox sx={{ mr: 0.5, display: "flex" }}>
                        <SoftTypography fontSize="15px" lineHeight="30px" width="135px">
                          Email:
                        </SoftTypography>

                        <SoftBox>
                          <SoftTypography
                            sx={{ fontWeight: 500, ml: 1 }}
                            fontSize="15px"
                            lineHeight="30px"
                          >
                            {veridetails?.email !== "" ? veridetails.email : "-"}
                          </SoftTypography>
                        </SoftBox>
                      </SoftBox>
                    </SProfileBox>
                  </Grid>

                  <Grid item lg={6} sm={12} md={12} xs={12}>
                    <SProfileBox>
                      <SoftBox sx={{ mr: 0.5, display: "flex" }}>
                        <SoftTypography fontSize="15px" lineHeight="30px" width="135px">
                          Mobile:
                        </SoftTypography>

                        <SoftBox>
                          <SoftTypography
                            sx={{ fontWeight: 500, ml: 1 }}
                            fontSize="15px"
                            lineHeight="30px"
                          >
                            {veridetails?.mobile !== "" ? veridetails.mobile : "-"}
                          </SoftTypography>
                        </SoftBox>
                      </SoftBox>
                    </SProfileBox>
                  </Grid>

                  <Grid item lg={6} sm={12} md={12} xs={12}>
                    <SProfileBox>
                      <SoftBox sx={{ mr: 0.5, display: "flex" }}>
                        <SoftTypography fontSize="15px" lineHeight="30px" width="135px">
                          Date of Birth:
                        </SoftTypography>

                        <SoftBox>
                          <SoftTypography
                            sx={{ fontWeight: 500, ml: 1 }}
                            fontSize="15px"
                            lineHeight="30px"
                          >
                            {veridetails.date_of_birth === "" || veridetails.date_of_birth === null
                              ? "-"
                              : moment(veridetails.date_of_birth).format("DD-MM-YYYY")}
                          </SoftTypography>
                        </SoftBox>
                      </SoftBox>
                    </SProfileBox>
                  </Grid>

                  <Grid item lg={6} sm={12} md={12} xs={12}>
                    <SProfileBox>
                      <SoftBox sx={{ mr: 0.5, display: "flex" }}>
                        <SoftTypography fontSize="15px" lineHeight="30px" width="135px">
                          Qualification:
                        </SoftTypography>

                        <SoftBox>
                          <SoftTypography
                            sx={{ fontWeight: 500, ml: 1 }}
                            fontSize="15px"
                            lineHeight="30px"
                          >
                            {veridetails?.highest_education === "" ||
                            veridetails?.highest_education === "nan" ||
                            veridetails?.highest_education === null
                              ? "-"
                              : veridetails?.highest_education}
                          </SoftTypography>
                        </SoftBox>
                      </SoftBox>
                    </SProfileBox>
                  </Grid>

                  <Grid item lg={6} sm={12} md={12} xs={12}>
                    <SProfileBox>
                      <SoftBox sx={{ mr: 0.5, display: "flex" }}>
                        <SoftTypography fontSize="15px" lineHeight="30px" width="135px">
                          State:
                        </SoftTypography>

                        <SoftBox>
                          <SoftTypography
                            sx={{ fontWeight: 500, ml: 1 }}
                            fontSize="15px"
                            lineHeight="30px"
                          >
                            {veridetails?.state === "" ||
                            veridetails?.state === "nan" ||
                            veridetails?.state === null
                              ? "-"
                              : veridetails.state}
                          </SoftTypography>
                        </SoftBox>
                      </SoftBox>
                    </SProfileBox>
                  </Grid>

                  <Grid item lg={6} sm={12} md={12} xs={12}>
                    <SProfileBox>
                      <SoftBox sx={{ mr: 0.5, display: "flex" }}>
                        <SoftTypography fontSize="15px" lineHeight="30px" width="135px">
                          District:
                        </SoftTypography>

                        <SoftBox>
                          <SoftTypography
                            sx={{ fontWeight: 500, ml: 1 }}
                            fontSize="15px"
                            lineHeight="30px"
                          >
                            {veridetails?.district === "" ||
                            veridetails?.district === "nan" ||
                            veridetails?.district === null
                              ? "-"
                              : veridetails.district}
                          </SoftTypography>
                        </SoftBox>
                      </SoftBox>
                    </SProfileBox>
                  </Grid>

                  <Grid item lg={6} sm={12} md={12} xs={12}>
                    <SProfileBox>
                      <SoftBox sx={{ mr: 0.5, display: "flex" }}>
                        <SoftTypography fontSize="15px" lineHeight="30px" width="135px">
                          Taluka:
                        </SoftTypography>

                        <SoftBox>
                          <SoftTypography
                            sx={{ fontWeight: 500, ml: 1 }}
                            fontSize="15px"
                            lineHeight="30px"
                          >
                            {veridetails?.taluka === "" ||
                            veridetails?.taluka === "nan" ||
                            veridetails?.taluka === null
                              ? "-"
                              : veridetails?.taluka}
                          </SoftTypography>
                        </SoftBox>
                      </SoftBox>
                    </SProfileBox>
                  </Grid>

                  <Grid item lg={6} sm={12} md={12} xs={12}>
                    <SProfileBox>
                      <SoftBox sx={{ mr: 0.5, display: "flex" }}>
                        <SoftTypography fontSize="15px" lineHeight="30px" width="135px">
                          Skills:
                        </SoftTypography>

                        <SoftBox>
                          <SoftTypography
                            sx={{ fontWeight: 500, ml: 1 }}
                            fontSize="15px"
                            lineHeight="30px"
                          >
                            {veridetails.skills === null ||
                            veridetails.skills === "nan" ||
                            veridetails.skills === ""
                              ? "-"
                              : veridetails.skills}
                          </SoftTypography>
                        </SoftBox>
                      </SoftBox>
                    </SProfileBox>
                  </Grid>

                  <Grid item lg={6} sm={12} md={12} xs={12}>
                    <SProfileBox>
                      <SoftBox sx={{ mr: 0.5, display: "flex" }}>
                        <SoftTypography fontSize="15px" lineHeight="30px" width="135px">
                          Experience:
                        </SoftTypography>

                        <SoftBox>
                          <SoftTypography
                            sx={{ fontWeight: 500, ml: 1 }}
                            fontSize="15px"
                            lineHeight="30px"
                          >
                            {veridetails?.experience === "" ||
                            veridetails?.experience === "nan" ||
                            veridetails?.experience === null
                              ? "-"
                              : veridetails.experience}{" "}
                            Year(s)
                          </SoftTypography>
                        </SoftBox>
                      </SoftBox>
                    </SProfileBox>
                  </Grid>

                  <Grid item lg={6} sm={12} md={12} xs={12}>
                    <SProfileBox>
                      <SoftBox sx={{ mr: 0.5, display: "flex" }}>
                        <SoftTypography fontSize="15px" lineHeight="30px" width="135px">
                          Data Source:
                        </SoftTypography>

                        <SoftBox>
                          <SoftTypography
                            sx={{ fontWeight: 500, ml: 1 }}
                            fontSize="15px"
                            lineHeight="30px"
                          >
                            {veridetails?.dataSource === "" ||
                            veridetails?.dataSource === "nan" ||
                            veridetails?.dataSource === null
                              ? "-"
                              : veridetails.dataSource}
                          </SoftTypography>
                        </SoftBox>
                      </SoftBox>
                    </SProfileBox>
                  </Grid>

                  <Grid item lg={6} sm={12} md={12} xs={12}>
                    <SProfileBox>
                      <SoftBox sx={{ mr: 0.5, display: "flex" }}>
                        <SoftTypography fontSize="15px" lineHeight="30px" width="135px">
                          Desired Role:
                        </SoftTypography>

                        <SoftBox>
                          <SoftTypography
                            sx={{ fontWeight: 500, ml: 1 }}
                            fontSize="15px"
                            lineHeight="30px"
                          >
                            {veridetails?.job_role === "" ||
                            veridetails?.job_role === "nan" ||
                            veridetails?.job_role === null
                              ? "-"
                              : veridetails.job_role}
                          </SoftTypography>
                        </SoftBox>
                      </SoftBox>
                    </SProfileBox>
                  </Grid>

                  <Grid item lg={6} sm={12} md={12} xs={12}>
                    <SProfileBox>
                      <SoftBox sx={{ mr: 0.5, display: "flex" }}>
                        <SoftTypography fontSize="15px" lineHeight="30px" width="135px">
                          Current Salary:
                        </SoftTypography>

                        <SoftBox>
                          <SoftTypography
                            sx={{ fontWeight: 500, ml: 1 }}
                            fontSize="15px"
                            lineHeight="30px"
                          >
                            {veridetails?.current_salary === "" ||
                            veridetails?.current_salary === "nan" ||
                            veridetails?.current_salary === null
                              ? "-"
                              : veridetails.current_salary}
                          </SoftTypography>
                        </SoftBox>
                      </SoftBox>
                    </SProfileBox>
                  </Grid>

                  <Grid item lg={6} sm={12} md={12} xs={12}>
                    <SProfileBox>
                      <SoftBox sx={{ mr: 0.5, display: "flex" }}>
                        <SoftTypography fontSize="15px" lineHeight="30px" width="135px">
                          Company:
                        </SoftTypography>

                        <SoftBox>
                          <SoftTypography
                            sx={{ fontWeight: 500, ml: 1 }}
                            fontSize="15px"
                            lineHeight="30px"
                          >
                            {candData?.industry === "" ||
                            candData?.industry === "nan" ||
                            candData?.industry === null
                              ? "-"
                              : candData.industry}
                          </SoftTypography>
                        </SoftBox>
                      </SoftBox>
                    </SProfileBox>
                  </Grid>

                  <Grid item lg={6} sm={12} md={12} xs={12}>
                    <SProfileBox>
                      <SoftBox sx={{ mr: 0.5, display: "flex" }}>
                        <SoftTypography fontSize="15px" lineHeight="30px" width="135px">
                          Modified on:
                        </SoftTypography>

                        <SoftBox>
                          <SoftTypography
                            sx={{ fontWeight: 500, ml: 1 }}
                            fontSize="15px"
                            lineHeight="30px"
                          >
                            {veridetails?.modified === "" ||
                            veridetails?.modified === "nan" ||
                            veridetails?.modified === null
                              ? "-"
                              : veridetails.modified}
                          </SoftTypography>
                        </SoftBox>
                      </SoftBox>
                    </SProfileBox>
                  </Grid>

                  <Grid item lg={6} sm={12} md={12} xs={12}>
                    <SProfileBox>
                      <SoftBox sx={{ mr: 0.5, display: "flex" }}>
                        <SoftTypography fontSize="15px" lineHeight="30px" width="135px">
                          Last Active:
                        </SoftTypography>

                        <SoftBox>
                          <SoftTypography
                            sx={{ fontWeight: 500, ml: 1 }}
                            fontSize="15px"
                            lineHeight="30px"
                          >
                            {veridetails?.lastactive === "" ||
                            veridetails?.lastactive === "nan" ||
                            veridetails?.lastactive === null
                              ? "-"
                              : veridetails.lastactive}
                          </SoftTypography>
                        </SoftBox>
                      </SoftBox>
                    </SProfileBox>
                  </Grid>

                  <Grid item lg={6} sm={12} md={12} xs={12}>
                    <SProfileBox>
                      <SoftBox sx={{ mr: 0.5, display: "flex" }}>
                        <SoftTypography fontSize="15px" lineHeight="30px" width="135px">
                          Bot Nurturing Done:
                        </SoftTypography>

                        <SoftBox>
                          <SoftTypography
                            sx={{ fontWeight: 500, ml: 1 }}
                            fontSize="15px"
                            lineHeight="30px"
                          >
                            No
                          </SoftTypography>
                        </SoftBox>
                      </SoftBox>
                    </SProfileBox>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            <Grid item lg={4} md={12} sm={12} xs={12}>
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  border: "1px solid grey",
                  borderRadius: "12px",
                  p: 1,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    p: 1,
                    textAlign: "center",
                    borderRadius: "8px",
                    background: "#3B5092",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "18px",
                      fontWeight: 400,
                      lineHeight: "26px",
                      fontFamily: "Poppins",
                      color: "#FFFFFF",
                    }}
                  >
                    Timeline
                  </Typography>
                </Box>

                <Box sx={{ p: 1 }}>
                  <Timeline time={time} setTime={setTime} timelineLoading={timelineLoading} />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}

SideDrawer.propTypes = {
  openModal: PropTypes.boolean,
  setOpenModal: PropTypes.boolean,
  veridetails: PropTypes.object,
  setVeridetails: PropTypes.object,
  timelineLoading: PropTypes.boolean,
  setTimeLineLoading: PropTypes.boolean,
  time: PropTypes.array,
  setTime: PropTypes.array,
  candData: PropTypes.object,
  setCandData: PropTypes.object,
};
